// Auto-generated by scripts/write-build-info.js — do not edit by hand.
export const BUILD_SHA = "ts-1786502454544";
export const BUILT_AT = "2026-08-12T02:40:54.544Z";
